export default {
  parameters: {
    landing_id: "IDCdGreen",
  },
  downtimeUrl: "https://id.kodland.tech",
  ageRules: {
    min: 5,
    max: 17,
  },
  startPage: {
    startBackground: "#E4FF9C",
    quizBackground: "#white",
    title: '<div align="center"><b>Selesaikan survei 2 menit dan dapatkan undangan kelas pemrograman GRATIS</div></b>',
    image: {
      url:  "/welcome/quiz_indo_custom_start_screen_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_indo_custom_start_screen_mobile.png",
      style: {
        width: "100%",
      },
    },
    button: {
      text: "    Mulai 🚀    ",
      style: {
        background: "#FFFFFF",
        color: "#18182E",
        "font-weight": "bold",
      },
    },
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    2: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
        "🏛️ Ilmu budaya",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    3: {
      question:
        "Apakah anda ingin waktu yang dihabiskan anak anda di depan komputer menjadi lebih produktif?",
      answers: ["😍 Ya!", "🙂 Tidak. Ini hanya untuk bersenang-senang dan tidak masalah."],
    },
  },
};

